import { BaseDataService } from '../../../services/base/BaseDataService';
import { ModelAction } from '../../../types/responses/ModelAction';
import { WorkflowInstance } from '../../workflows/models/WorkflowInstance';
import { Act } from '../models/Act';
import { ProjectDocFolder } from '../models/ProjectDocFolder';
import { ProjectDocFolderQuery } from '../models/ProjectDocFolderQuery';

export class ProjectDocFolderService extends BaseDataService<ProjectDocFolder, ProjectDocFolderQuery> {
    protected prefixUrl: string = `ProjectDocFolders`;

    actions(id: number) {
        return this.api.get<ModelAction[]>(`${this.prefixUrl}/Actions?id=${id}`);
    }

    getTree(docTemplateId: number) {
        return this.api.get<ProjectDocFolder[]>(`${this.prefixUrl}/GetTree?projectDocId=${docTemplateId}`);
    }

    reorder(ids: number[]) {
        const idsParam: { [position: number]: number } = {};
        for (let i = 0; i < ids.length; i++) idsParam[i + 1] = ids[i];

        return this.api.post(`${this.prefixUrl}/Reorder`, idsParam);
    }

    addAct(data: AddActModel) {
        return this.api.post<ProjectDocFolder>(`${this.prefixUrl}/addAct`, data);
    }

    getAct(docFolderId: number) {
        return this.api.get<Act>(`${this.prefixUrl}/getAct?docFolderId=${docFolderId}`);
    }

    getActPrevIteration(docFolderId: number) {
        return this.api.get<ActWorkflowInstanceModel>(
            `${this.prefixUrl}/getActPrevIteration?docFolderId=${docFolderId}`
        );
    }

    saveAct(docFolderId: number, data: Act) {
        return this.api.post<Act>(`${this.prefixUrl}/saveAct?docFolderId=${docFolderId}`, data);
    }

    getEdiSigningPackage(docFolderId: number) {
        return this.api.get<EdiSigningPackage | null>(
            `${this.prefixUrl}/GetEdiSigningPackage?docFolderId=${docFolderId}`
        );
    }

    addActDocument(data: AddActDocumentModel) {
        return this.api.post<ProjectDocFolder>(`${this.prefixUrl}/addActDocument`, data);
    }

    downloadActExport(actId: number) {
        return this.downloadFile(`Acts/Export?id=${actId}`);
    }

    refreshActSigners(docFolderId: number) {
        return this.api.post<Act>(`${this.prefixUrl}/RefreshActSigners?docFolderId=${docFolderId}`, {});
    }

    getAvailableActTemplates(folderId: number) {
        return this.api.get<any[]>(`${this.prefixUrl}/GetAvailableActTemplates?folderId=${folderId}`);
    }
}

export interface AddActModel {
    ProjectDocFolderId: number;
    ActTemplateId: number;
    Title: string;
    Cypher: string;
    DocumentDate: Date | string;
}

export interface AddActDocumentModel {
    ProjectDocFolderId: number;
    ActDocumentTypeId: number;
    Title: string;
    Cypher: string;
    DocumentDate: Date | string;
    DocumentDateEnd?: Date | string;
    DocumentKindId?: number;
    DocumentKindCustom?: string;
    DocumentOrganization?: string;
}

export interface ActWorkflowInstanceModel {
    Act?: Act;
    WorkflowInstance?: WorkflowInstance;
}

export interface EdiSigningPackage {
    Id: number;
    Status: number;
    CorrelationId?: string;
    ExpectedExternalSignatureCount: number;
    ReceivedExternalSignatureCount: number;
    IsDocumentLocked: boolean;
    SentAt?: Date;
    CompletedAt?: Date;
    LastError?: string;
}
